import { render, staticRenderFns } from "./CardPayment.vue?vue&type=template&id=840dc202&scoped=true&"
import script from "./CardPayment.vue?vue&type=script&lang=js&"
export * from "./CardPayment.vue?vue&type=script&lang=js&"
import style0 from "./CardPayment.vue?vue&type=style&index=0&id=840dc202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840dc202",
  null
  
)

export default component.exports